import { render, staticRenderFns } from "./autoPaymentForPreson.vue?vue&type=template&id=1abb8326&scoped=true"
import script from "./autoPaymentForPreson.vue?vue&type=script&lang=js"
export * from "./autoPaymentForPreson.vue?vue&type=script&lang=js"
import style0 from "./autoPaymentForPreson.vue?vue&type=style&index=0&id=1abb8326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb8326",
  null
  
)

export default component.exports